<router-outlet></router-outlet>
<div *ngIf="saasSettingsService.appInitialized$ | async" class="disabled-overlay">
  <mat-spinner [diameter]="60" color="primary"></mat-spinner>
</div>
